<ng-container *ngIf="page_summary_loaded">
	<div class="new-summary-section">
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{commonService.abbreviateNumber(page_summary_data.total_leads)}}</p>
			<p class="each-new-summary-section-label">Leads</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_summary_data.total_opportunity)}}</p>
			<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
		</div>
		<div class="each-new-summary-section" *ngIf="selected_tab != 'MAGI' && user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14">
			<p class="each-new-summary-section-count">{{page_summary_data.avg_wallet_share}}</p>
			<p class="each-new-summary-section-label">Additional Book Value</p>
		</div>
		<div class="each-new-summary-section">
			<div class="each-new-summary-section-switch">
				<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis"></mat-slide-toggle>
			</div>
			<p class="each-new-summary-section-label">View Analysis</p>
		</div>
		<div class="each-new-summary-section">
			<div class="each-new-summary-section-switch">
				<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()"></mat-slide-toggle>
			</div>
			<p class="each-new-summary-section-label">Graphical Representation</p>
		</div>
	</div>

	<!-- <ng-container>
		<app-agent-one-view [type]="type"></app-agent-one-view>
	</ng-container> -->

	<ng-container *ngIf="page_graph_data_loaded && show_analysis">
		<!-- <div class="page-graphs-section">
			<div class="opp-breakdown-section">
				<div class="page-graph-heading-section">
					<img src="assets/events.png" class="page-graph-heading-icon" />
					<span>Opportunities Breakdown</span>
				</div>
				<div class="each-page-graph-content">
					<div id="breakdown-graph"></div>
				</div>
			</div>
			<div class="opp-detail-graph-section">
				<div class="each-page-graph-block">
					<div class="page-graph-heading-section">
						<img src="assets/events.png" class="page-graph-heading-icon" />
						<span>Rule Based Triggers Breakdown</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section" style="width: 400px; left: unset; right: 0;">
								<div class="module-page-information-section" *ngFor="let section of rule_based_tooltip_section">
									<div class="each-module-page-information-section">
										<p class="each-module-page-information-heading">{{section.name}}</p>
									</div>
									<ng-container *ngIf="section.sub_sections">
										<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
											<div class="each-module-page-information-sub-section">
												<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
											</div>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
					<div class="each-page-graph-content">
						<div id="rule-based-breakdown-graph"></div>
					</div>
				</div>
				<div class="each-page-graph-block">
					<div class="page-graph-heading-section">
						<img src="assets/events.png" class="page-graph-heading-icon" />
						<span>AI Triggers Breakdown</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section" style="width: 400px; left: unset; right: 0;">
								<div class="module-page-information-section" *ngFor="let section of ai_based_tooltip_section">
									<div class="each-module-page-information-section">
										<p class="each-module-page-information-heading">{{section.name}}</p>
									</div>
									<ng-container *ngIf="section.sub_sections">
										<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
											<div class="each-module-page-information-sub-section">
												<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
											</div>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
					<div class="each-page-graph-content">
						<div id="ai-triggers-breakdown-graph"></div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- <app-stage-process-analysis [opp_type]="'Opportunity'" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis> -->
		<app-stage-process-analysis-v2 [opp_type]="'Opportunity'" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis-v2>
	</ng-container>

	<ng-container *ngIf="page_graph_data_loaded">
		<div class="page-graphs-section" [hidden]="!show_graphical_representation">
			<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="graphSlideConfig">
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Opportunities by Year</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="opp-year-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Activities by Communication Channel</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="communication-channel-activities-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Activities by Months</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="monthly-activities-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Upside Opportunities</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="upside-opportunity-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Age Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="age-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Date Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="date-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Data Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="data-triggers-graph"></div>
					</div>
				</div>
        		<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by AI Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="ai-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block" *ngIf="user_details.role.business_area[0] == 5">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Value</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="value-clients-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block" *ngIf="user_details.role.business_area[0] == 5">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Closure Time</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="closure-time-clients-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block" *ngIf="user_details.role.business_area[0] == 5">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Clients by Value/Closure Time</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="value-closure-clients-graph"></div>
					</div>
				</div>
			</ngx-slick-carousel>
		</div>
	</ng-container>
	<ng-container *ngIf="!page_graph_data_loaded && show_graphical_representation">
		<app-loader [loading_text]="'Loading Graphical Representation'"></app-loader>
	</ng-container>

	<!-- <ng-container>
		<div class="analysis-heading-section">
			<span>{{type}} Analysis</span>
			<div class="section-heading-tooltip-block">
				<img src="assets/info-black.png" />
				<div class="section-heading-tooltip-section">
					<p>The goal of this analysis slider is to help determine where the greatest value lies and where advisors should focus their efforts. It also aids advisors in understanding how many leads they can handle personally, how many should be reassigned to Assistant Financial Advisors (AFAs), and the remainder to be managed by the AI Advisor Assistant. This ensures that no opportunity is missed, regardless of time constraints and value limitations.</p>
					<p>The goal of this analysis slider is to help determine where the greatest value lies and where advisors should focus their efforts. It also aids advisors in understanding how many leads they can handle personally, how many should be reassigned to Junior Advisors, and the remainder to be managed by the AI Advisor Assistant. This ensures that no opportunity is missed, regardless of time constraints and value limitations.</p>
					<br />
					<p>The section corresponding to the analysis slider on the left displays a graphical representation of the analysis and the predicted outcomes in terms of values.</p>
				</div>
			</div>
		</div>
		<div class="page-summary-analysis-section">
			<div class="page-summary-analysis-calculator-section">
				<div class="each-summary-calculator-questions-section">
					<p class="each-summary-calculator-question">What Top percentage of opportunities would you like to work with</p>
					<div class="summary-calculator-slider-section">
						<span class="summary-calculator-slider-label">1%</span>
						<div class="summary-calculator-slider">
							<mat-slider thumbLabel [displayWith]="formatLabel" min="1" max="100" step="1"[(ngModel)]="selected_top_percentage" (input)="opportunitySliderChanged($event);" (change)="opportunitySliderStopped()"></mat-slider>
						</div>
						<span class="summary-calculator-slider-label">100%</span>
					</div>
					<div class="summary-calculator-slider-input-section">
						<input type="number" class="each-summary-calculator-question-input" [min]="1" [max]="100" [(ngModel)]="selected_top_percentage" (input)="validateSliderValue($event); opportunitySliderStopped();" />
					</div>
				</div>
				<div class="each-summary-calculator-questions-section">
					<p class="each-summary-calculator-question">With what percentage of upside opportunity</p>
					<div class="summary-calculator-slider-section">
						<span class="summary-calculator-slider-label">1%</span>
						<div class="summary-calculator-slider">
							<mat-slider thumbLabel [displayWith]="formatLabel" min="1" max="100" step="1"[(ngModel)]="selected_analysis_value" (input)="upsideOpportunitySliderChanged($event);" (change)="opportunitySliderStopped()"></mat-slider>
						</div>
						<span class="summary-calculator-slider-label">100%</span>
					</div>
					<div class="summary-calculator-slider-input-section">
						<input type="number" class="each-summary-calculator-question-input" [min]="1" [max]="100" [(ngModel)]="selected_analysis_value" (input)="validateSliderValue($event); opportunitySliderStopped();" />
					</div>
				</div>
				<div class="each-summary-calculator-questions-section">
					<p class="each-summary-calculator-question">Automated activities will be executed for all the <strong><span *ngIf="type == 'Total Opportunities'">{{page_summary_data.total_leads}}</span> <span *ngIf="type == 'Up-Sell Opportunities'">{{page_summary_data.up_sell_leads}}</span>
					<span *ngIf="type == 'Cross-Sell Opportunities'">{{page_summary_data.cross_sell_leads}}</span></strong> identified {{type}}. As an Advisor you can start manually reaching out to top <strong>{{selected_top_percentage}}%</strong> of clients.</p>
				</div>
			</div>
			<div class="page-summary-analysis-details-section">
				<div class="page-summary-analysis-details-graph-section">
					<p class="page-summary-analysis-details-heading">High Value Clients: {{selected_high_value_leads}}</p>
					<ng-container *ngIf="opportunity_graph_loaded">
						<div id="opportunity-graph"></div>
					</ng-container>
					<ng-container *ngIf="!opportunity_graph_loaded">
						<p class="page-summary-analysis-details-graph-loader">Loading Graph...</p>
					</ng-container>
				</div>
				<div class="page-summary-analysis-graph-details-section" *ngIf="opportunity_graph_loaded">
					<div class="each-page-summary-analysis-graph-details-section" *ngFor="let data of opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data']; let index = index" [style.borderColor]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]">
						<div class="each-page-summary-analysis-graph-details">
							<p class="each-page-summary-analysis-graph-details-label">{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['labels'][index]}} Opportunity</p>
							<p class="each-page-summary-analysis-graph-details-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(data)}} <span class="each-page-summary-analysis-graph-details-label" style="width: auto;">({{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data_percentage'][index]}}%)</span></p>
						</div>
						<div class="each-page-summary-analysis-graph-details">
							<p class="each-page-summary-analysis-graph-details-label">Additional Book Value</p>
							<p class="each-page-summary-analysis-graph-details-count">{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['book_value'][index]}}</p>
						</div>
						<div class="page-summary-graph-legend-section">
							<div class="page-summary-graph-legend-circle" [style.background]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]"></div>
							<span class="page-summary-graph-legend-name" [style.color]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]">Represents {{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['labels'][index]}} Clients</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="page-summary-recommendation-section" *ngIf="opportunity_graph_loaded">
			<p class="each-summary-recommendation-content">By concentrating on the top <strong>{{selected_top_percentage}}%</strong> of {{type}}, you have the potential to acquire <strong>{{selected_high_value_leads}}</strong> clients, representing <strong>{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data_percentage'][0]}}%</strong> of the total predicted opportunity, thereby achieving an <strong>{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['book_value'][0]}}</strong> enhancement in the overall book value.</p>

			<p class="each-summary-recommendation-heading">Recommendation:</p>
			<p class="each-summary-recommendation-content">By strategically targeting a specific percentage of top opportunities, you can significantly increase client acquisition as detailed below:</p>
			<table class="each-summary-recommendation-table">
				<thead>
					<tr>
						<th>Top Percentage of Opportunites</th>
						<th>Predicted Opportunity Capture</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let recomendation of opportunity_recomendation_data">
						<td>{{recomendation.top_percentage}}</td>
						<td>{{recomendation.predicted_opportunity_capture}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<ng-container *ngIf="!opportunity_graph_loaded">
			<app-loader [loading_text]="'Loading Recommendation'"></app-loader>
		</ng-container>
	</ng-container> -->

	<div class="summary-table-data-section">
		<div class="summary-table-section">
			<div>
				<!-- <div class="move-records-section">
					<button class="move-records-button" (click)="openMoveRecordModal()">Move to Stage</button>
					<span class="page-modal-input-label" *ngIf="selected_table_data.length > 0">{{selected_table_data.length}} Record(s) Selected</span>
					<span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more clients to move</span>
				</div> -->
				<div class="new-table-v2-overflow">
					<div class="new-table-heading-section">
						<div class="my-4">

							<span class="new-filter-tag" *ngIf="opp_year_id != ''">
								{{ opp_year_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_year_id = ''; opp_year_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
							</span>

							<span class="new-filter-tag" *ngIf="upside_opportunity_id != ''">
								{{ upside_opportunity_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" upside_opportunity_id = ''; upside_opportunity_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
							</span>

							<span class="new-filter-tag" *ngIf="client_value_id != ''">
								{{ client_value_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" client_value_id = ''; client_value_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
							</span>

							<span class="new-filter-tag" *ngIf="client_closure_id != ''">
								{{ client_closure_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" client_closure_id = ''; client_closure_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData()"/>
							</span>

							<span class="new-filter-tag" *ngIf="age_trigger_id != ''">
								{{ age_trigger_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" age_trigger_id = ''; age_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() " />
							</span>

							<span class="new-filter-tag" *ngIf="date_trigger_id != ''">
								{{ date_trigger_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" date_trigger_id = ''; date_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
							</span>

							<span class="new-filter-tag" *ngIf="data_trigger_id != ''">
								{{ data_trigger_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" data_trigger_id = ''; data_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>
              				<span class="new-filter-tag" *ngIf="ai_trigger_id != ''">
								{{ ai_trigger_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" ai_trigger_id = ''; ai_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>

							<span class="new-filter-tag" *ngIf="opp_breakdown_id != ''">
								{{ opp_breakdown_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_breakdown_id = ''; opp_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>
							<span class="new-filter-tag" *ngIf="rules_breakdown_id != ''">
								{{ rules_breakdown_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" rules_breakdown_id = ''; rules_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>
							<span class="new-filter-tag" *ngIf="ai_breakdown_id != ''">
								{{ ai_breakdown_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" ai_breakdown_id = ''; ai_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>

							<span class="new-filter-tag" *ngIf="common_breakdown_id != ''">
								{{ common_breakdown_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" common_breakdown_id = ''; common_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
								/>
							</span>

						</div>
						<!-- <span style="visibility: hidden;">S</span> -->
						<span>AI Explainability</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section">
							  <div class="module-page-information-section" *ngFor="let section of upside_opportunity_ai_explainability_sections">
								<div class="each-module-page-information-section">
								  <p class="each-module-page-information-heading">{{section.name}}</p>
								</div>
								<ng-container *ngIf="section.sub_sections">
								  <ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
									<div class="each-module-page-information-sub-section">
									  <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
									  <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>

									  <ng-container *ngIf="sub_section.sub_sections">
										<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
										  <p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
										  <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
										</div>
									  </ng-container>

									</div>
								  </ng-container>
								</ng-container>
							  </div>
							</div>
						  </div>
						<div class="new-table-actions ml-4">
							<div class="each-action-section search-input-section" *ngIf="show_search">
								<input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; getTableData()" />
								<span class="search-input-close" (click)=" show_search = false; search_key = ''; current_pagination_page = 1; getTableData() ">&times;</span>
							</div>
							<div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true" >
								<img src="assets/search.png" class="button-icon" />
								<span>Search</span>
							</div>
							<div class="each-action-section dynamic-columns-section">
								<img src="assets/column-filter.png" class="button-icon" (click)="show_toggle_columns = !show_toggle_columns" />
								<div class="dynamic-columns" *ngIf="show_toggle_columns">
									<div class="dynamic-column-heading-section">
										<span>Filter Columns</span>
										<span class="columns-close" (click)="show_toggle_columns = false" >&times;</span >
									</div>
									<div class="dynamic-column-content">
										<div class="each-column-section" *ngFor="let column of table_columns" >
											<mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked" >{{ column.name }}</mat-checkbox>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="alphabets-filter-section">
							<p class="new-each-filter-alphabet" [ngClass]="{'new-filter-alphabet-selected': alphabet == selected_alphabet}" *ngFor="let alphabet of alphabets_array" (click)=" current_pagination_page = 1; selected_alphabet = alphabet; getTableData() " style="margin-bottom: 8px !important" > {{ alphabet }}</p>
							<p class="clear-filter-alphabet" (click)=" current_pagination_page = 1; selected_alphabet = ''; getTableData() " > Clear</p>
						</div>
					</div>
					<div class="new-table-v2-overflow">
						<table class="new-table-v2">
							<thead>
								<tr>
									<th appColumnResizable>
										<!-- <div class="record-selection-section">
											<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
										</div> -->
										Actions
									</th>
									<!-- <th appColumnResizable>Activities</th> -->
									<th appColumnResizable>Activities</th>
									<!-- <ng-container *ngFor="let column of table_columns">
										<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
									</ng-container> -->
									<ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
										<ng-container *ngSwitchCase="'trigger'">
										  <th appColumnResizable *ngIf="column.checked" style="width: 350px;">{{ column.name }}</th>
										</ng-container>
										<ng-container *ngSwitchCase="'trigger_condition'">
										  <th appColumnResizable *ngIf="column.checked" style="width: 500px;">{{ column.name }}</th>
										</ng-container>
										<ng-container *ngSwitchDefault>
										  <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
										</ng-container>
									</ng-container>
								</tr>
							</thead>
							<ng-container *ngIf="table_data_loaded">
								<tbody *ngIf="table_data.length > 0">
									<ng-container *ngFor=" let client of table_data | paginate : { 	id: 'interactions-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: total_pagination_records }; let clientIndex = index " >
										<tr>

											<td>
												<!-- <div class="record-selection-section">
													<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
												</div> -->
												<!-- <img
												src="assets/view-tasks.png"
												class="client-table-icon"
												(click)="openClientDataModal(client)"
												/> -->
												<img
												src="assets/view-tasks.png"
												class="client-table-icon"
												(click)="showUserProfile(client)"
												/>
												<img
												src="assets/ic-blue-upsell.png"
												class="client-table-icon"
												(click)="openAddOpportunityModal(client)"
												[matTooltip]="'Add to Upside Opportunities'"
												*ngIf="client.advisor_recommendation == true"
												/>
												<ng-container>
													<img
														src="assets/sync-icon.png"
														class="client-table-icon"
														*ngIf="user_details.Salesforce_connected && !salesforce_sync_loader"
														(click)="salesforceSync(client)"
														[matTooltip]="'Sync Activities'"
													/>
													<img
														src="assets/sync-icon.png"
														class="client-table-icon"
														*ngIf="user_details.Salesforce_connected && salesforce_sync_loader"
														[matTooltip]="'Sync Activities'"
													/>
												</ng-container>
												<img src="assets/exclamation-icon.png" class="client-table-icon" *ngIf="client.trigger_status == 'Inactive'" [matTooltip]="client.trigger_description" />
											</td>
											<td>
												<img src="assets/ic-activities.png" class="client-table-icon" (click)="toggleActivityView(clientIndex)" />
											</td>


											<ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key" >
												<ng-container *ngSwitchCase="'advisor_status'">
													<td *ngIf="column.checked">
														<p class="status-tag completed-status">
															{{ client.advisor_status }}
														</p>
													</td>
												</ng-container>
												<ng-container *ngSwitchCase="'ai_rank'">
													<td class="highlight-table-cell" *ngIf="column.checked">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>
												<ng-container *ngSwitchCase="'opportunity'">
													<td class="highlight-table-cell" *ngIf="column.checked">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>
												<ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
													<td class="highlight-table-cell" *ngIf="column.checked">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>

												<ng-container *ngSwitchCase="'predicted_closure_days'">
													<td class="highlight-table-cell" *ngIf="column.checked">
														{{ getTableKey(client, column) }} Day(s)
													</td>
												</ng-container>
												<ng-container *ngSwitchCase="'recommended_products'">
													<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getTableKey(client, column)">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>

												<ng-container *ngSwitchCase="'preferred_channel'">
													<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getTableKey(client, column)">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>

												<ng-container *ngSwitchCase="'trigger'">
													<td *ngIf="column.checked">
													  <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getTableKey(client, column) }}</span>
													</td>
												  </ng-container>

												<ng-container *ngSwitchDefault>
													<td *ngIf="column.checked">
														{{ getTableKey(client, column) }}
													</td>
												</ng-container>
											</ng-container>
										</tr>
										<tr *ngIf="show_activity_view == clientIndex">
											<td colspan="10" class="page-inner-view" style="overflow: visible;">
												<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="1" [selected_view_type]="'View'" [activity_action_type]="'View'" [activity_action_type]="'View'" [stepper_stage]="stepper_stage" (dataChanged)="changeStepper()"></app-activities>
											</td>
										</tr>
									</ng-container>
								</tbody>
								<tbody *ngIf="table_data.length == 0">
									<td colspan="15">
										<div class="zero-state-section">
											<span>No Data Found</span>
										</div>
									</td>
								</tbody>
							</ng-container>
							<ng-container *ngIf="!table_data_loaded">
								<tbody>
									<tr>
										<td colspan="15" class="zero-state-section">
											<app-loader
											[loading_text]="'Loading Clients Data'"
											></app-loader>
										</td>
									</tr>
								</tbody>
							</ng-container>
						</table>
					</div>
					<div class="new-table-v2-pagination-section">
						<span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
						<mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; getTableData()">
							<mat-option [value]="10">10</mat-option>
							<mat-option [value]="100">100</mat-option>
							<mat-option [value]="500">500</mat-option>
							<mat-option [value]="1000">1000</mat-option>
						</mat-select>
						<div class="new-table-v2-pagination-controls">
							<pagination-controls id="interactions-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</ng-container>

<ng-container *ngIf="!page_summary_loaded">
	<app-loader [loading_text]="'Loading'"></app-loader>
</ng-container>

<ng-template #clientDataModal>
	<div class="modal-section client-details-modal">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Know Your Client</span>
			<span class="client-modal-icon" (click)="closeClientDataModal()">&times;</span>
		</div>
		<div class="modal-content-section" *ngIf="!selected_modal_client_loader">
			<app-client-profile [client_data]="selected_modal_client"></app-client-profile>
		</div>
		<div class="modal-content-section" *ngIf="selected_modal_client_loader">
			<app-loader [loading_text]="'Loading Client Profile'"></app-loader>
		</div>
	</div>
</ng-template>

<ng-template #addOpportunityModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Add Client to Upside Opportunities</span>
			<span class="client-modal-icon" (click)="closeAddOpportunityModal()">&times;</span>
		</div>
		<div class="modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to add this client to Opportunities?</p>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="addOpportunity()">Yes</button>
			<button class="page-modal-secondary-button" (click)="closeAddOpportunityModal()">No</button>
		</div>
	</div>
</ng-template>

<!-- Move Record Modal HTML -->
<ng-template #moveRecordModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Change Stage</span>
			<span class="client-modal-icon" (click)="closeMoveRecordModal()">&times;</span>
		</div>
		<div class="modal-content-section" style="padding: 24px 0;">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Select Stage</p>
				<mat-select class="page-modal-input" [(ngModel)]="move_record_stage">
					<mat-option [value]="''">Select Stage</mat-option>
					<mat-option *ngFor="let stage of stages_data" [value]="stage.id">{{stage.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="move_record_stage_error">Stage is Required.</p>
			</div>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark Stage Activities as Not Required</mat-checkbox>
			</div>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="changeClientStage()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeMoveRecordModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="show_user_profile">
	<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
  </ng-container>


<ng-template #syncActivitiesModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Syncing Activities</span>
			<!-- <span class="client-modal-icon" (click)="closeSyncActivitiesModal()">&times;</span> -->
		</div>
		<div class="modal-content-section">
			<div class="page-modal-delete-description">
				<div>
					<img src="assets/sync-icon.png" class="rotating-image" />
				</div>
				<span>Syncing In Progress ...</span>
			</div>
		</div>
	</div>
</ng-template>
